import Masonry from 'masonry-layout';
import {classList, cssVars, dataset, listen} from 'nuffjs';
import {waitMs} from '../utils/wait';

const conf = {
	itemsAttr: 'items',
	itemAttr: 'item',
	columnWidthItemAttr: 'item',
	enabledClass: 'masonryEnabled',
	readyClass: 'masonryReady',
	gutterProp: 'gutterSize',
	masonryLayoutEnabledProp: 'masonryLayoutEnabled',
	readyDelay: 10, // ms
};

class MasonryLayout extends HTMLElement {
	items = null;
	layout = null;

	static defaultOpts = {
		columnWidthSelector: dataset.selector(conf.columnWidthItemAttr),
	};

	connectedCallback() {
		this.opts = dataset(this).get(this.constructor.defaultOpts);
		this.items = this.querySelector(dataset.selector(conf.itemsAttr));
		this.resizeListener = listen(window, 'resize', this.onResize.bind(this), {throttle: true});
		this.update();
	}

	disconnectedCallback() {
		this.resizeListener.unlisten();
	}

	onResize(event) {
		requestAnimationFrame(() => this.update());
	}

	update() {
		const enabled = cssVars(this).get(conf.masonryLayoutEnabledProp, true);
		classList(this.items).toggle(conf.enabledClass, enabled);
		if (enabled) {
			if (!this.layout) {
				const params = {
					itemSelector: dataset.selector(conf.itemAttr),
					percentPosition: true,
					gutter: cssVars(this).get(conf.gutterProp, 20),
				};
				const columnWidthItem = this.querySelector(this.opts.columnWidthSelector);
				if (columnWidthItem) {
					params.columnWidth = columnWidthItem;
					params.transitionDuration = 0;
				}
				this.layout = new Masonry(this.items, params);
				// the documented layoutComplete event does not fire, so we force a little delay
				waitMs(conf.readyDelay).then(() => classList(this.items).add(conf.readyClass));
			}
		} else {
			if (this.layout) {
				this.layout.destroy();
				this.layout = null;
				classList(this.items).remove(conf.readyClass);
			}
		}
	}
}

export {MasonryLayout};
